



















































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class SessionCard extends Vue {
  @Prop({ type: String, default: "" }) time!: string;
  @Prop({ type: Object, default: null }) availability!: any;
  @Prop({ type: String, default: "" }) instructorName!: string;
  @Prop({ type: String, default: "" }) instructorImage!: string;
  @Prop({ type: String, default: "" }) date!: string;
  @Prop({ type: String, default: "" }) duration!: string;
  @Prop({ type: String, default: "" }) capacity!: string;
  @Prop({ type: String, default: "" }) price!: string;

  get availabilityLabel() {
    if (!this.availability || !this.availability.label) {
      return "";
    }
    return this.availability.label;
  }

  get availabilityClass() {
    if (!this.availability || !this.availability.type) {
      return "";
    }
    return this.availability.type === "low"
      ? "sessionCard__status--low"
      : "sessionCard__status--ok";
  }

  get instructorInitials() {
    if (!this.instructorName) return "";
    const parts = this.instructorName.trim().split(" ");
    return parts
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  }

  get hasMeta() {
    return this.date !== "" || this.duration !== "" || this.capacity !== "";
  }

  get showPrice() {
    return this.price !== "" && this.price !== null && this.price !== undefined;
  }

  emitAction() {
    this.$emit("action");
  }
}
